<template>
  <el-dialog
    append-to-body
    width="500px"
    title="无法到岗"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="name" label="报名用户：">
        {{ info.nickname }}
      </el-form-item>
      <el-form-item prop="name" label="工作时间：">
        <div v-for="(item, index) in info.part_hours" :key="index">
          {{ item }}
        </div>
      </el-form-item>
      <el-form-item prop="refund_type" label="保证金9.9:">
        <el-radio-group v-model="form.data.refund_type">
          <el-radio :label="1">原路退款</el-radio>
          <el-radio :label="2">不予退款</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
        <el-button @click="toggle(false)">取消</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      info: {},
      visible: false,
      loading: false,
      form: {
        loading: false,
        data: {
          refund_type: 1,
        },
        rules: {
          date: [{ required: true, message: "必填项", trigger: "change" }],
        },
      },
    };
  },
  created() {},
  methods: {
    reset(done) {
      this.info = {};
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(row) {
      this.info = row;
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let params = {
            id: this.info.id,
            status:2,
            refund_type:this.form.data.refund_type,
          };
          this.$http
            .post("/admin/order/arrival", params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
